<template>
    <div class="wpb__container page_content">

        <alf-stories-sidebar
                :title="title"
                :story-categories="storyCategories">

        </alf-stories-sidebar>

        <alf-view-filter :selected-view="columnClass"
                         v-on:changed-filter-view="setColumnClass">

        </alf-view-filter>

        <transition name="fade" mode="out-in">
            <alf-loader v-show="isFetching"></alf-loader>
        </transition>

        <alf-stories-items
                :stories="stories"
                :column-class="columnClass"
                :in-depth="inDepth">
        </alf-stories-items>

        <alf-infinite-loading v-if="renderInfinite" v-show="enoughPosts" @distance="1" @infinite="infiniteHandler" :identifier="infiniteIdentifier">
            <span slot="no-more">
                {{ noMoreResultsText }}
            </span>
        </alf-infinite-loading>

    </div>

</template>
<script>

    import helpers from '../../helpers';
    import 'jquery-match-height'
    import axios from 'axios';
    import StoryItems from './stories-items';
    import StoryItemsSideBar from './stories-sidebar';
    import ViewFilter from './stories-view-filter';
    import Loader from '.././loader'
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        components: {
            'alf-stories-items': StoryItems,
            'alf-stories-sidebar': StoryItemsSideBar,
            'alf-view-filter': ViewFilter,
            'alf-loader': Loader,
            'alf-infinite-loading': InfiniteLoading
        },
        props: {
            'newsItemList': {required: true},
            'title': {required: true},
            'type': {required: false},
            'storyCategories': {required: true},
        },
        data: function(){
            return {
                helpers: helpers,
                stories: [],
                isFetching: false,
                columnClass: 'one-column',
                inDepth: false,
                fetchTypeUrl: this.$route.fullPath.split('/')[2],
                page: 2,
                renderInfinite: true,
                infiniteIdentifier: new Date().getTime(),
                styleObject: {
                    float: 'right'
                }
            }
        },
        watch:{
            '$route.params.slug': function() {
                const slug = this.$route.params.slug;

                // $state
                if(slug) {
                    this.fetchNewProducts(slug)
                }
            },
        },
          beforeMount: function() {
            if(this.type === "in-depth") {
              this.inDepth = true;
            }
          },
        mounted: function(){
            this.stories = this.newsItemList;
            this.page = this.pageNumber;

            console.dir(this.type);


            this.matchArticleHeights();
        },
        methods: {
            fetchNewProducts: function(slug){
                let _this = this;
                _this.renderInfinite = false;
                _this.page = 2;
                _this.isFetching = true;
                //
                let fetchUrlStart = '/en/' + this.fetchTypeUrl + '/category/';
                if(helpers.getLocale() === 'nl')
                    fetchUrlStart = '/nl/'  + this.fetchTypeUrl +  '/categorie/';

                axios.get(fetchUrlStart + slug + '?locale=' + helpers.getLocale())
                    .then(function (response) {
                        // Set new listing state
                        _this.stories = response.data;

                        _this.$nextTick(function(){
                            _this.infiniteIdentifier = new Date().getTime();
                        });

                        //jquery plugin to match the heights...
                        setTimeout(function(){
                            _this.matchArticleHeights();
                        }, 300);

                        _this.isFetching = false;
                        _this.renderInfinite = true;
                    })
                    .catch(function (error) {
                        //console.error(error);
                        _this.isFetching = false
                    })
            },
            infiniteHandler($state) {
                let _this = this;

                let storyCategorySlug = '';
                if(this.$route.params.slug !== undefined){
                    storyCategorySlug = this.getCategoryUrlPrefix + this.$route.params.slug;
                }

                let url = "/en/" + this.fetchTypeUrl + storyCategorySlug +  "?page=" + this.page + '&locale=' + helpers.getLocale();
                if(helpers.getLocale() === 'nl'){
                    url = "/nl/" + this.fetchTypeUrl + storyCategorySlug + "?page=" + this.page + '&locale=' + helpers.getLocale();
                }
                $.get(url)
                    .then(response => {

                        // console.dir(response);

                        if(response.length < 1) {
                            return $state.complete();
                        }
                        $.each(response, function (key, value) {
                            _this.stories.push(value);
                        });
                        $state.loaded();
                        _this.page = _this.page + 1;

                        //jquery plugin to match the heights...
                        setTimeout(function(){
                            _this.matchArticleHeights();
                        }, 300);

                    });
            },
            matchArticleHeights: function() {
                $('.home__posts-content h3').matchHeight({byRow: true});
            },
            setColumnClass: function(columnClass){
                let _this = this;
                this.columnClass = columnClass;

                // jquery plugin to match the heights...
                setTimeout(function(){
                    _this.matchArticleHeights();
                }, 300);
            }
        },
        computed: {
            noMoreResultsText: function (){
                if(helpers.getLocale() === 'nl'){
                    return 'Geen resultaten meer'
                }

                return 'No more results';
            },
            getCategoryUrlPrefix: function(){
                let categoryUrl = '/category/';
                if(helpers.getLocale() === 'nl'){
                    categoryUrl = '/categorie/'
                }
                return categoryUrl;
            },
            enoughPosts: function(){
                return this.stories.length > 4;
            },
            pageNumber: function(){
                var url = new URL(window.location.href);
                var page = url.searchParams.get("page");
                return page !== null ? parseInt(page) + 1 : 2 ;
            },
        }
    }

</script>
<style lang="scss" scoped>
    .loader {
        padding-top: 0!important;
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/site/components/stories/stories-root.vue